import React, { useState } from "react";
import {
  FaImage,
  FaVideo,
  FaGlobe,
  FaPaperPlane,
  FaVideoSlash,
} from "react-icons/fa";
import CreatePost from "../feedpost/createpost"; // ✅ import your modal component
import CreatepostforSeller from "../feedpost/createpostforseller";

const PostBox = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-4 border rounded-2xl px-4 py-3 bg-[#F9F9F9] shadow-sm">
        {/* Left: Avatar + Input */}
        <div className="flex items-center flex-grow bg-white rounded-full px-4 py-2">
            <div
          className="flex items-center flex-grow bg-white rounded-full px-4 py-2 cursor-pointer"
          onClick={() => setIsModalOpen(true)} // ✅ open modal on click
        ></div>
          <img
            src="/image/PostInputImage.png"
            alt="avatar"
            className="w-8 h-8 rounded-full object-cover mr-3"
          />
          <input
            type="text"
            placeholder="Share Something"
            className="flex-grow  placeholder-gray-500 outline-none bg-transparent text-sm text-gray-700 cursor-pointer"
          />
        </div>

        {/* Middle: Media Options */}
        <div className="flex items-center gap-4 text-sm text-gray-700">
          <div className="flex items-center gap-1 hover:text-red-600">
            <input
              type="file"
              accept="application/pdf"
              id="image"
              className="hidden"
            />
            <label
              htmlFor="image"
              className="flex items-center gap-2 cursor-pointer"
            >
              <FaImage className="text-red-600 text-xl" />
              Image
            </label>
          </div>
          <button className="flex items-center gap-1 hover:text-green-700">
            <FaVideo className="text-green-700  text-xl" />
            Video
          </button>
          <button className="flex items-center gap-1 hover:text-black">
            <FaGlobe className="text-black  text-xl" />
            <select className="bg-transparent">
              <option>Public</option>
              <option>Private</option>
            </select>
          </button>
        </div>

        {/* Right: Actions */}
        <div className="flex items-center gap-3">
          <button className=" bg-gradient-to-r from-[#08AEEA] to-[#1DE78B]  text-white text-sm px-4 py-2 rounded-full flex items-center gap-1 hover:opacity-90 transition ">
            <FaPaperPlane />
            Post
          </button>
          <button className="bg-red-600 text-white text-sm px-4 py-2 rounded-full flex items-center gap-1 hover:bg-red-700 transition">
            <FaVideoSlash />
            Go Live
          </button>
        </div>
      </div>
        {/* ✅ Modal (CreatePost) */}
      {isModalOpen && (
        <CreatepostforSeller onClose={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};

export default PostBox;
